import React from "react";

// styles
import breakpoints from "core/breakpoints";
import { useViewport } from "js/hooks/useViewport";

// components
import AttributionDesktop from "./AttributionDesktop";
import AttributionModal from "./AttributionModal";

const Attribution = () => {
    const { browserWidth } = useViewport();
    const isDesktop = browserWidth >= breakpoints.tablet.px;
    return isDesktop ? <AttributionDesktop /> : <AttributionModal />;
};

export default Attribution;
